import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PaymentService } from '../../core/services/payment.service';
import { EStatus } from '../../core/enums/status.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyService } from '../../core/services/notify.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.css']
})
export class PaymentStatusComponent implements OnInit {
  isLoading = false;
  referenceNumer!: string;
  serverUrl!: string;
  frontendUrl!: string;
  checkoutInfo!: any;
  copied = false;
  message!: any;
  redirectUrl = '';
  public EStatus = EStatus

  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private notifyService: NotifyService
  ) {

  }

  @Output() retryPayment = new EventEmitter<void>();

  ngOnInit() {
    this.route.paramMap.subscribe((params: any) => {
      this.referenceNumer = params?.get('reference');
      this.getReferenceInfo(this.referenceNumer);
    });
  }

  getReferenceInfo(reference: string): void {
    this.isLoading = true;
    this.paymentService.getReference(reference).subscribe(res => {
      this.isLoading = false;
      this.checkoutInfo = res;

    });
  }

  get isCompleted(): boolean {
    return this.checkoutInfo?.transactionStatus === EStatus.COMPLETED;
  }

  get isPending(): boolean {
    return this.checkoutInfo?.transactionStatus === EStatus.PENDING;
  }

  get isFailed(): boolean {
    return this.checkoutInfo?.transactionStatus === EStatus.FAILED;
  }

  get statusTitle(): string {
    if (this.isCompleted) return 'Payment Successful';
    if (this.isPending) return 'Payment Pending';
    return 'Payment Failed';
  }

  get retryPaymentUrl(): string {
    if (this.checkoutInfo?.callBackUrl) {
      const url = new URL(this.checkoutInfo.callBackUrl);
      url.searchParams.append('paymentStatus', 'failed');
      url.searchParams.append('retry', 'true');
      return url.toString();
    }
    return this.checkoutInfo?.callBackUrl || '/';
  }

}
